// extracted by mini-css-extract-plugin
module.exports = {"Box":"BoxedLayout_Box__1VRJ1","BoxContainer":"BoxedLayout_BoxContainer__3GCTL","Success":"BoxedLayout_Success__1b_2p","Inactive":"BoxedLayout_Inactive__2KvNe"};